import styled from "styled-components";
import fipayFont from "../../../theme/index";
import { colors } from "../../../theme/color";

export const ContentWrapperCon = styled.div`
  background-color: #f7f7f7;
  padding: 30px;
  margin-top: 40px;
  position: absolute;
  @media screen and (max-width: 768px) {
    /* border: 2px solid red; */
    margin: 56px auto 0;
    width: 100%;
    margin-top: 3.125rem;
    align-self: center;
    padding: 20px;
  }
  /* margin-top: 56px; */
  /* Fill the width of the viewport */
  /* border: 2px solid red */
  /* margin-top: 3.125rem; */
  /* width: 98vw; */
  /* width: 25rem; */
  /* @media (min-width: 1023px) {
    min-width: 900px;
  } */
`;

export const SecondContWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;

  @media screen and (max-width: 768px) {
    width: 50%;
  }
`;

export const PaymentLinkHeader = styled.div`
  width: 40%;
  /* border: 1px solid red; */
`;

export const GoBackContainer = styled.h3``;

export const PaymentLinkHeaderText = styled.h3`
  height: 32px;
  margin-left: 20px;
  /* margin-top: 25px; */
  /* border: 1px solid red; */
  color: ${colors.NAVYBLUE};
  font-size: ${fipayFont.fipayFonts.fontSize.heading3};
  font-weight: ${fipayFont.fipayFonts.fontWeight.medium};
  @media screen and (max-width: 767px) {
    font-size: ${fipayFont.fipayFonts.fontSize.body1};
  }
`;

export const PaymentLinkHeaderBeneathText = styled.p`
  /* margin-top: -18px; */
  color: ${colors.DARK_GRAY};
  font-size: ${fipayFont.fipayFonts.fontSize.body3};
  font-weight: ${fipayFont.fipayFonts.fontWeight.regular};
`;

export const PaymentLinkButtonContainer = styled.div`
  padding-top: 30px;
  width: 20%;
  /* border: 1px solid red; */
`;

export const HeaderText = styled.h1`
  text-align: center;
  color: ${colors.NAVYBLUE};
  margin: 20px 0;
  padding-top: 70px;
`;
